<template>
  <div>
    <v-btn v-if="false" fab depressed color="primary" small :to="`/regalos/campaign/${campaign_id}`"
      ><v-icon>mdi-chevron-left</v-icon></v-btn
    >

    <!-- breadcrumb (testing removing it now)-->
    <div v-if="false">
      <router-link :to="`/regalos`">Regalos</router-link>
      &gt;
      <router-link :to="`/regalos/campaign/${campaign_id}`"> {{ campaign.title }}</router-link>
    </div>

    <div v-if="true" style="display: flex; justify-content: space-between; align-items: center">
      <div>
        <router-link :to="`/regalos/campaign/${campaign_id}`">
          <v-icon color="blue">mdi-chevron-left</v-icon>
          {{ campaign.title }}
        </router-link>
      </div>

      <!-- menu -->
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab depressed small color="success" v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list style="border-radius: 12px">
          <v-list-item @click="goToEdit">
            <v-list-item-title>Editar idea</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteIdea">
            <v-list-item-title style="color: red">Eliminar</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <h1>
      {{ idea.title }} <span v-if="false" class="modern-link" @click="goToEdit">editar</span>
      <span v-if="false"><v-icon>mdi-dots-vertical</v-icon></span>
    </h1>
    <p>{{ idea.description }}</p>

    <!-- mark as completed-->
    <div v-if="idea.options && idea.options.filter((o) => o.purchased).length">
      <v-checkbox
        v-model="idea.completed"
        :label="`Completado con ${idea.options.filter((o) => o.purchased === true).length} opción comprada`"
      ></v-checkbox>
    </div>
    <div v-else>
      <v-checkbox v-model="idea.discarded" label="Descartar esta idea"></v-checkbox>
    </div>

    <!-- options list -->
    <div v-if="idea.options && idea.options.length > 0">
      <h2>Opciones</h2>
      <div>
        <!-- list of options, discarded last, purchased first-->
        <div
          v-for="option in [...idea.options].sort((a, b) => (a.discarded ? 1 : a.purchased ? -1 : 0))"
          :key="option.id"
        >
          <OpcionListItem :option="option" :campaign="campaign" :campaign_id="campaign_id" :idea_id="idea_id" />
        </div>
      </div>
    </div>

    <!-- no options yet, let's make it easy to add the first one -->
    <div v-if="idea.options && !idea.options.length">
      <p>Añade productos concretos para materializar esta idea.</p>
    </div>

    <!--add button-->
    <v-fab-transition>
      <v-btn fab bottom right fixed color="success" @click="addOption" :loading="loading" style="margin-bottom: 56px">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import api from '@/assets/api'
import { v4 as uuidv4 } from 'uuid'
import OpcionListItem from './OpcionListItem.vue'

export default {
  components: {
    OpcionListItem,
  },
  props: {
    campaign_id: {
      type: String,
      default: '',
    },
    idea_id: {
      type: String,
      default: '',
    },
  },
  watch: {
    idea: {
      deep: true,
      handler(newValue, oldValue) {
        //avoid saving when we just loaded the data
        if (oldValue.id) {
          this.save()
        }
      },
    },
  },
  data() {
    return {
      campaign: {},
      idea: {},
      loading: false,
    }
  },
  methods: {
    async deleteIdea() {
      alert('Idea deletion not implemented yet.')
      /*
      if (!confirm('¿Estás seguro de que quieres eliminar esta idea? Esta acción no se puede deshacer.')) return
      this.loading = true
      let x = await api.apiFetch(`/regalos/idea?id=${this.idea_id}`, {
        method: 'DELETE',
      })
      this.loading = false
      if (!x.ok) return alert('something failed')
      this.$router.push(`/regalos/campaign/${this.campaign_id}`)
    */
    },
    async save() {
      this.loading = true
      let x = await api.apiFetch(`/regalos/idea`, {
        method: 'POST',
        body: JSON.stringify(this.idea),
      })
      this.loading = false
      if (!x.ok) return alert('something failed')
    },

    goToEdit() {
      this.$router.push(`/regalos/campaign/${this.campaign_id}/idea/${this.idea_id}/edit`)
    },
    async addOption() {
      const new_id = uuidv4()
      const newOption = {
        campaign_id: this.campaign_id,
        idea_id: this.idea_id,
        id: new_id,
        title: '',
        description: '',
        price: 0,
        image_url: '',
        link: '',
      }
      this.loading = true
      let x = await api.apiFetch(`/regalos/option`, {
        method: 'POST',
        body: JSON.stringify(newOption),
      })
      this.loading = false
      if (!x.ok) return alert('something failed')
      let j = await x.json()
      if (!this.idea.options) this.idea.options = []
      this.idea.options.push(j)
      this.$router.push(`/regalos/campaign/${this.campaign_id}/idea/${this.idea_id}/option/${new_id}/edit`)
    },
    async fetchData() {
      this.loading = true
      let x = await api.apiFetch(`/regalos/campaign?id=${this.campaign_id}`)
      this.loading = false
      if (!x.ok) return alert('something failed')
      let j = await x.json()
      this.campaign = j
      if (!j.ideas) j.ideas = []
      const idea = j.ideas.find((i) => i.id == this.idea_id)
      if (!idea) return alert('idea not found')
      this.idea = idea
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
